export default function NotFound(){
    return (
        <div>
            El contenido que estás buscando no se encuentra disponible.
        </div>
    )
}